import React, {useEffect} from 'react';
import Body from "./components/Body";
import Card from "./components/Card";
import Brand from "./components/Brand";
import {observer} from "mobx-react-lite";
import ItemsStore from "./store/ItemsStore";
import Table from "./components/Table"
import ProviderInfo from "./components/ProviderInfo";
import moment from "moment";
import "moment/locale/ru"

import Status from "./components/Status";
import AddFields from "./components/AddFields";
const App = observer(() => {

    useEffect(() => {

        const path = window.location.pathname.split("/")

        if (path[3]) {
            ItemsStore.loadPreset(parseInt(path[3]), path[2]).then(() => {
                if (ItemsStore.Preset) {
                    ItemsStore.addStylesHTML(ItemsStore.Preset.styles)
                }
            })
        } else {
            ItemsStore.loadScore(path[2]).then(() => {
                ItemsStore.setIsScore(true)
                if (ItemsStore.Preset) {
                    ItemsStore.addStylesHTML(ItemsStore.Preset.styles)
                }
            })
        }

    }, [])

    return (
        <Body>
            <Brand image={!ItemsStore.loading_state ? "https://products.amo.tools/logo.png" : undefined} title={!ItemsStore.loading_state ? "AMO.TOOLS" : undefined} />
            <Card>
                {
                    ItemsStore.loading_state
                        ? "Загрузка..."
                        : (!ItemsStore.Preset
                            ? "Не удалось получить запрашиваемую информацию"
                            : (
                               <>
                                 <div className="TopInfo">
                                    {
                                    ItemsStore.Preset.provider ? <ProviderInfo provider={ItemsStore.Preset.provider} /> :
                                       (
                                           ItemsStore.Preset.user.name.length > 0 ?
                                               <ProviderInfo provider={{
                                                   field_name: "ПОСТАВЩИК",
                                                   value: {
                                                       address: ItemsStore.Preset.user.address,
                                                       bank_code: ItemsStore.Preset.user.bic,
                                                       entity_type: null,
                                                       external_uid: null,
                                                       kpp: ItemsStore.Preset.user.iec,
                                                       name: ItemsStore.Preset.user.name,
                                                       tax_registration_reason_code: ItemsStore.Preset.user.psrn,
                                                       vat_id: ItemsStore.Preset.user.itn,
                                                   }
                                               }} />
                                               : ""
                                       )
                                    }
                                     {
                                         ItemsStore.Preset.payer.length > 0 ? (
                                             <AddFields title={"Информация о плательщике"} items={ItemsStore.Preset.payer} />
                                         ) : ""
                                     }
                                     {
                                         ItemsStore.Preset.lead_add_fields.length > 0 ? (
                                             <AddFields title={"Дополнительная информация"} items={ItemsStore.Preset.lead_add_fields} />
                                         ) : ""
                                     }
                                 </div>
                                <div className="TableInfo">
                                    <span className="TableInfo__Title">
                                        {ItemsStore.Preset.name} от {moment(ItemsStore.Preset.date).locale("ru").format("L")}
                                        { ItemsStore.isScore && ItemsStore.Preset.status ? ( <Status status_id={ItemsStore.Preset.status} /> ) : "" }
                                    </span>
                                    <Table preset={ItemsStore.Preset} />
                                </div>
                               </>
                            )
                        )
                }

            </Card>
        </Body>
    );
})

export default App;
